import { buildUrl } from '@diritto/common/utils/urls';
import { configure } from 'utils/configure';
import { normalizeReturnUrl } from 'utils/normalizer';

export const buildSignInUrl = (returnUrl?: string) =>
  returnUrl ? buildUrl('/accounts/sign-in', { returnUrl: normalizeReturnUrl(returnUrl) }) : '/accounts/sign-in';

export const buildCertificateUrl = (returnUrl?: string) =>
  returnUrl ? buildUrl('/accounts/certificate', { returnUrl: normalizeReturnUrl(returnUrl) }) : '/accounts/certificate';

export const getFullUrl = (path: string) => `${configure.serviceUrl}${path}`;

export const buildEpisodeReplyUrl = (reply: {
  id: number;
  parentId?: number;
  contentId?: number;
  episodeId?: number;
}) => {
  if (reply.contentId === undefined || reply.episodeId === undefined) {
    return `/replies/${reply.id}`;
  }

  return reply.parentId
    ? `/contents/${reply.contentId}/episodes/${reply.episodeId}/replies/${reply.parentId}?focusedReplyId=${reply.id}`
    : `/contents/${reply.contentId}/episodes/${reply.episodeId}/replies?focusedReplyId=${reply.id}`;
};

export const isDirittoDomain = (url: string) => url.match(/^https:\/\/.*\.diritto\.(co\.kr|dev|work)\//);
